(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-slider-component')) {
    class VideoSliderComponent extends HTMLElement {
      connectedCallback() {
        if (this.initialized || this.initializationFrame) return;

        this.initializationFrame = window.requestAnimationFrame(() => {
          this.initializationFrame = null;
          if (!this.isConnected) return;
          this.initialize();
        });
      }

      initialize() {
        if (this.initialized) return;

        this.initialized = true;
        this.list = this.querySelector('.video-slider-list');
        this.cards = Array.from(this.querySelectorAll('.video-slider-item'));

        if (!this.list || this.cards.length === 0) {
          this.initialized = false;
          return;
        }

        this.mobileQuery = window.matchMedia('(max-width: 800px)');
        this.mp4ImageSupported = undefined;
        this.failedCards = new WeakSet();
        this.activeToken = 0;
        this.inViewport = !('IntersectionObserver' in window);

        this.handleModeChange = this.updateMode.bind(this);
        this.handleScrollEnd = this.activateDominantCard.bind(this);
        this.handleFallbackScroll = this.onFallbackScroll.bind(this);
        this.handleBlockSelect = this.onBlockSelect.bind(this);
        this.handleVisibilityChange = this.onVisibilityChange.bind(this);

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener('change', this.handleModeChange);
        } else {
          this.mobileQuery.addListener(this.handleModeChange);
        }

        this.hasNativeScrollEnd = 'onscrollend' in this.list;

        if (this.hasNativeScrollEnd) {
          this.list.addEventListener('scrollend', this.handleScrollEnd);
        } else {
          this.list.addEventListener('scroll', this.handleFallbackScroll, { passive: true });
        }

        this.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        if ('IntersectionObserver' in window) {
          this.sectionObserver = new IntersectionObserver(
            ([entry]) => {
              this.inViewport = entry.isIntersecting;

              if (!this.mobileQuery.matches) return;

              if (this.inViewport && !document.hidden) {
                this.activateDominantCard();
              } else {
                this.removeMobileAnimation();
              }
            },
            { threshold: 0.01 }
          );
          this.sectionObserver.observe(this);
        }

        this.updateMode();
      }

      disconnectedCallback() {
        if (this.initializationFrame) {
          window.cancelAnimationFrame(this.initializationFrame);
          this.initializationFrame = null;
        }

        if (!this.initialized) return;

        window.clearTimeout(this.scrollTimer);

        if (this.mobileQuery) {
          if (this.mobileQuery.removeEventListener) {
            this.mobileQuery.removeEventListener('change', this.handleModeChange);
          } else {
            this.mobileQuery.removeListener(this.handleModeChange);
          }
        }

        if (this.list) {
          if (this.hasNativeScrollEnd) {
            this.list.removeEventListener('scrollend', this.handleScrollEnd);
          } else {
            this.list.removeEventListener('scroll', this.handleFallbackScroll);
          }
        }

        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.sectionObserver?.disconnect();
        this.removeMobileAnimation();
        this.removeDesktopVideos();
        this.initialized = false;
      }

      updateMode() {
        if (!this.mobileQuery || !this.list) return;

        window.clearTimeout(this.scrollTimer);

        if (this.mobileQuery.matches) {
          this.removeDesktopVideos();

          if (this.inViewport && !document.hidden) {
            this.activateDominantCard();
          }
        } else {
          this.removeMobileAnimation();
          this.mountDesktopVideos();
        }
      }

      mountDesktopVideos() {
        this.cards.forEach((card) => {
          const media = card.querySelector('.testimonial__image');
          const template = card.querySelector('template[data-desktop-video]');

          if (!media || !template || media.querySelector('video')) return;

          const fragment = template.content.cloneNode(true);
          const video = fragment.querySelector('video');
          if (video) {
            video.muted = true;
            video.defaultMuted = true;
            video.playsInline = true;
            video.autoplay = true;
          }

          media.appendChild(fragment);

          if (video) {
            try {
              const playPromise = video.play();
              if (playPromise?.catch) playPromise.catch(() => {});
            } catch {
              // The autoplay attributes remain the desktop fallback.
            }
          }
        });
      }

      removeDesktopVideos() {
        this.querySelectorAll('.testimonial__image > video').forEach((video) => {
          video.pause();
          video.removeAttribute('src');
          video.querySelectorAll('source').forEach((source) => source.removeAttribute('src'));
          video.load();
          video.remove();
        });
      }

      onFallbackScroll() {
        if (!this.mobileQuery.matches || !this.inViewport) return;

        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(this.handleScrollEnd, 140);
      }

      onVisibilityChange() {
        if (!this.mobileQuery?.matches) return;

        if (document.hidden) {
          this.removeMobileAnimation();
        } else if (this.inViewport) {
          this.activateDominantCard();
        }
      }

      onBlockSelect(event) {
        if (!(event.target instanceof Element)) return;

        const card = event.target.closest('.video-slider-item');
        if (!card || !this.contains(card)) return;

        const listBounds = this.list.getBoundingClientRect();
        const cardBounds = card.getBoundingClientRect();
        const desiredLeft =
          this.list.scrollLeft +
          (cardBounds.left - listBounds.left) -
          (this.list.clientWidth - cardBounds.width) / 2;
        const maximumLeft = Math.max(0, this.list.scrollWidth - this.list.clientWidth);

        this.list.scrollTo({
          left: Math.min(maximumLeft, Math.max(0, desiredLeft)),
          behavior: 'auto',
        });

        if (this.mobileQuery?.matches) this.activateCard(card);
      }

      activateDominantCard() {
        if (!this.mobileQuery?.matches || !this.inViewport || document.hidden) return;

        const listBounds = this.list.getBoundingClientRect();
        const currentCard = this.requestedCard || this.activeCard;
        let dominantCard = null;
        let dominantWidth = 0;

        this.cards.forEach((card) => {
          const cardBounds = card.getBoundingClientRect();
          const visibleWidth = Math.max(
            0,
            Math.min(cardBounds.right, listBounds.right) - Math.max(cardBounds.left, listBounds.left)
          );

          if (
            visibleWidth > dominantWidth ||
            (Math.abs(visibleWidth - dominantWidth) < 0.5 && card === currentCard)
          ) {
            dominantCard = card;
            dominantWidth = visibleWidth;
          }
        });

        if (dominantCard) this.activateCard(dominantCard);
      }

      activateCard(card) {
        this.cards.forEach((item) => item.classList.toggle('is-selected', item === card));

        if (!this.mobileQuery?.matches || !this.inViewport || document.hidden) return;
        if (this.activeCard === card && this.activeImage) return;
        if (this.requestedCard === card && this.pendingImage) return;

        this.claimMobileOwnership();
        this.disposeImage();

        if (this.failedCards.has(card)) {
          this.releaseMobileOwnership();
          return;
        }

        this.requestedCard = card;

        const media = card.querySelector('.testimonial__image');
        const mp4Url = card.dataset.mp4Image;
        const webpUrl = card.dataset.webpImage;
        let usingMp4 = Boolean(mp4Url) && this.mp4ImageSupported !== false;
        const initialUrl = usingMp4 ? mp4Url : webpUrl;

        if (!media || !initialUrl) {
          this.requestedCard = null;
          this.releaseMobileOwnership();
          return;
        }

        const image = new Image();
        const token = this.activeToken;

        image.className = 'video-slider-mobile-animation';
        image.alt = '';
        image.decoding = 'async';
        image.draggable = false;
        image.setAttribute('aria-hidden', 'true');
        this.pendingImage = image;

        image.onload = () => {
          if (
            token !== this.activeToken ||
            this.requestedCard !== card ||
            !this.isConnected ||
            !this.mobileQuery.matches ||
            !this.inViewport ||
            document.hidden
          ) {
            return;
          }

          if (usingMp4) this.mp4ImageSupported = true;

          this.pendingImage = null;
          this.requestedCard = null;
          this.activeCard = card;
          this.activeImage = image;
          media.appendChild(image);
        };

        image.onerror = () => {
          if (
            token !== this.activeToken ||
            this.requestedCard !== card ||
            !this.isConnected ||
            !this.mobileQuery.matches ||
            !this.inViewport ||
            document.hidden
          ) {
            return;
          }

          if (usingMp4 && webpUrl) {
            this.mp4ImageSupported = false;
            usingMp4 = false;
            image.src = webpUrl;
            return;
          }

          this.pendingImage = null;
          this.requestedCard = null;
          this.failedCards.add(card);
          image.onload = null;
          image.onerror = null;
          this.releaseMobileOwnership();
        };

        image.src = initialUrl;
      }

      disposeImage() {
        this.activeToken += 1;
        this.requestedCard = null;
        this.activeCard = null;

        if (this.pendingImage) {
          this.pendingImage.onload = null;
          this.pendingImage.onerror = null;
          this.pendingImage.removeAttribute('src');
          this.pendingImage = null;
        }

        if (this.activeImage) {
          this.activeImage.onload = null;
          this.activeImage.onerror = null;
          this.activeImage.removeAttribute('src');
          this.activeImage.remove();
          this.activeImage = null;
        }
      }

      removeMobileAnimation() {
        this.disposeImage();
        this.releaseMobileOwnership();
      }

      claimMobileOwnership() {
        const previousOwner = VideoSliderComponent.activeMobileOwner;

        if (previousOwner && previousOwner !== this) {
          previousOwner.removeMobileAnimation();
        }

        VideoSliderComponent.activeMobileOwner = this;
      }

      releaseMobileOwnership() {
        if (VideoSliderComponent.activeMobileOwner === this) {
          VideoSliderComponent.activeMobileOwner = null;
        }
      }
    }

    VideoSliderComponent.activeMobileOwner = null;
    customElements.define('video-slider-component', VideoSliderComponent);
  }

  } catch(e) { console.error(e); }
})();
})();
